import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
import { FunderCreate, PartnerCreate, PartnerGet } from "../../api/orgService";
import useApi from "../../api/useApi";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";

export default function AddpartnerForm({ onAddpartner }) {
  const [open, setOpen] = useState(false);
  const [fileUpload,setConstFileUpload] = useState(false)
  const { request: partnerCreate, data:partnerData, error:partnerError} = useApi(PartnerCreate);
  const { request: funderCreate, data:funderData, error:funderError} = useApi(FunderCreate);
  const { request: partnerGetAll, data:partnerGetAllData, error:partnerGetAllError} = useApi(PartnerGet);
  const navigate = useNavigate()
  const location = useLocation()
  const [partner, setPartner] = useState({
    partner_name: "",
    partnership_type:"",
    partner_description:"",
    partner_website:"",
    partner_logo: "",
    value: "",
  });
          
        useEffect(() => {
          // partnerGetAll();
               // eslint-disable-next-line
          }, []);

          useEffect(() => {
            if(partnerData!==null){
              // partnerGetAll();
            }
            // eslint-disable-next-line
            }, [partnerData]);
          
          useEffect(()=>{
            if (partnerData?.status===201) {
              // setAllArticles(partnerData?.data);
              toast.success(`${JSON.stringify(partnerData?.data,null,2)}`,{position: "top-center"});
            }
          // eslint-disable-next-line
          },[partnerData])

          useEffect(()=>{
            if (funderData?.status===201) {
              // setAllArticles(partnerData?.data);
              toast.success(`${JSON.stringify(funderData?.data,null,2)}`,{position: "top-center"});
              navigate(`${location?.pathname}`,{redirect:"org-detail-view"})
              setPartner({
                partner_name: "",
                partnership_type:"",
                partner_description:"",
                partner_website:"",
                partner_logo: "",
                value: "",
              })
            }
          // eslint-disable-next-line
          },[funderData])
      
        
          // useEffect(()=>{
          //     if(location?.state?.refresh==="org"){
          //       partnerCreate();
          //     }
          //   // eslint-disable-next-line
          //   },[location?.state])
        //   useEffect(()=>{
        //     if(partnerData){
                
        //   }
        // },[partnerData])
        
          useEffect(()=>{
              if(partnerError){
                  toast.error(`${JSON.stringify(partnerError?.response?.data,null,2)}`,{position: "top-center"});
                  
            }
          },[partnerError])

          useEffect(()=>{
            if(funderError){
                toast.error(`${JSON.stringify(funderError?.response?.data,null,2)}`,{position: "top-center"});
          }
        },[funderError])
  
//   Partner Name: The name of the organization or individual.

// Partnership Type: (e.g., Funding Partner, Technical Partner, Community Partner).

// Description: A brief overview of the partnership or contribution.

// Website / Contact Link: Optional link for visitors to learn more.

// Logo or Image: (optional) To visually represent the partner on the site.

  

  const [tabIndex, setTabIndex] = useState(0); // 0 = Link, 1 = Upload
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPartner((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file){
    const previewUrl = URL.createObjectURL(file);
    setPartner((prev) => ({ ...prev, value: previewUrl }));


    const formData = new FormData();
    formData.append("image", file);
    setConstFileUpload(true)
    try{
      // const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
      // const res = await fetch("http://127.0.0.1:8000/cms/ftp-files/", {
        const res = await fetch("/cms/ftp-files/", {
        method: "POST",
        body: formData, // don't add headers here
      });
    // console.log(res)
    if(res?.status===201){
      let result = await res.json()
      console.log("Upload urls: ",result)
      setPartner((prevData)=>({
        ...prevData,
        partner_logo: result?.path,
      }));
    // setMaterialUrl(event,event.target.value)
      // setUploadUrls(prev=>res?.data)
      setConstFileUpload(false)
    }else{
      console.log(res)
    }
    }catch(error){
      console.log(error)
    }

    }
    // if (file && onImageUpload) {
      
    // }
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     // Convert to local preview URL
  //     const previewUrl = URL.createObjectURL(file);
  //     setPartner((prev) => ({ ...prev, value: previewUrl }));
  //   }
  // };


  const handleSubmit = () => {
    if (!partner.partnership_type?.length>0) return alert("Please select partner type.");
    // onAddpartner(partner);
    if(partner.partnership_type === "Project Partner"){
      console.log(partner)
      partnerCreate(partner)
    }else if(partner.partnership_type === "Funding Partner"){
      let dataToSend = {
        funder_name: partner?.partner_name,
        funder_type:partner?.partnership_type,
        funder_description:partner?.partner_description,
        funder_website:partner?.partner_website,
        funder_logo:partner?.partner_logo,
      }
      funderCreate(dataToSend)
    }else{
      partnerCreate(partner)
    }
    // setPartner({ type: "text", heading: "", value: "" });
    setOpen(false);
  };

  return (
    <>
      {/* Add partner Button */}
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setOpen(true)}
        sx={{ mb: 2 }}
      >
        Add Partner
      </Button>

      {/* Popup Form */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add Partner</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <Typography
            sx={{
                mb:5,
            }}
            >Allows the organisation (Fountain Africa Trust) to record details of organizations, institutions, or individuals who collaborate or support its projects.
            </Typography>
            

            {/* Optional Heading */}
            <TextField
              name="partner_name"
              label="Partner Name"
              placeholder="The name of the organization or individual"
              value={partner.partner_name}
              onChange={handleChange}
              fullWidth
            />

            
            {/* Type Selector */}
            <TextField
              select
              name="partnership_type"
              label="Partnership Type"
              placeholder="(e.g., Funding Partner, Technical Partner, Community Partner, Project Partner)"
              value={partner.partnership_type}
              onChange={handleChange}
              fullWidth
            >
              <MenuItem value="Funding Partner">Funding Partner</MenuItem>
              <MenuItem value="Technical Partner">Technical Partner</MenuItem>
              <MenuItem value="Community Partner">Community Partner</MenuItem>
              <MenuItem value="Project Partner">Project Partner</MenuItem>
            </TextField>

            {/* Partner Description */}
            {/* Description: A brief overview of the partnership or contribution. */}
            <TextField
              name="partner_description"
              label="Description"
              placeholder="A brief overview of the partnership or contribution"
              value={partner.partner_description}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={4}
            />

            {/* Partner Website Link */}

            <TextField
              name="partner_website"
              label="Website / Contact Link"
              placeholder="Optional link for visitors to learn more"
              value={partner.partner_website}
              onChange={handleChange}
              fullWidth
              minRows={4}
            />
            
            {/* Logo image Input — varies by type */}
                <>
                  <Tabs
                    value={tabIndex}
                    onChange={(e, newValue) => setTabIndex(newValue)}
                    centered
                    sx={{ mb: 1 }}
                  >
                    <Tab label="Partner Logo Link" />
                    <Tab label="Upload Partner Logo" />
                  </Tabs>
  
                  {tabIndex === 0 ? (
                    <TextField
                      name="partner_logo"
                      label= "Image Logo URL or Path or Link"
                      value={partner.partner_logo}
                      onChange={handleChange}
                      fullWidth
                    />
                  ) : (
                    <Box
                      sx={{
                        border: "2px dashed #ccc",
                        borderRadius: 2,
                        p: 3,
                        textAlign: "center",
                      }}
                    >
                      {partner.partner_logo ? (
                        partner.partner_logo?.length >= 0 ? (
                          <img
                            src={partner.partner_logo}
                            alt="preview"
                            style={{
                              width: "100%",
                              borderRadius: "8px",
                              marginBottom: "8px",
                            }}
                          />
                        ) : (
                          <Typography variant="body2" sx={{ mb: 1 }}>
                            File selected: {partner.value.split("/").pop()}
                          </Typography>
                        )
                      ) : (
                        <UploadIcon sx={{ fontSize: 50, color: "#aaa", mb: 1 }} />
                      )}
  
                      <Button
                        variant="outlined"
                        onClick={() => fileInputRef.current.click()}
                      >
                        {partner.value ? "Change File" : "Upload File"}
                      </Button>
                      <input
                        type="file"
                        accept={"image/*"}
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />
                    </Box>
                  )}
                </>
            
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
